webpackJsonp([52],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/react-apollo-5-authentication.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<p>In this section, you’ll learn how you can implement authentication functionality with Apollo to provide signup and login features to your users.</p>\n<h3>Prepare the React components</h3>\n<p>As in the sections before, you’ll set the stage for the login functionality by preparing the React components that are needed for this feature. You’ll start by building the <code>Login</code> component.</p>\n<Instruction>\n<p>Create a new file in <code>src/components</code> and call it <code>Login.js</code>. Then paste the following code into it:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/Login.js\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> React<span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span> Component <span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'react'</span>\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span> AUTH_TOKEN <span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'../constants'</span>\n\n<span class=\"token keyword\">class</span> <span class=\"token class-name\">Login</span> <span class=\"token keyword\">extends</span> <span class=\"token class-name\">Component</span> <span class=\"token punctuation\">{</span>\n  state <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n    login<span class=\"token punctuation\">:</span> <span class=\"token boolean\">true</span><span class=\"token punctuation\">,</span> <span class=\"token comment\" spellcheck=\"true\">// switch between Login and SignUp</span>\n    email<span class=\"token punctuation\">:</span> <span class=\"token string\">''</span><span class=\"token punctuation\">,</span>\n    password<span class=\"token punctuation\">:</span> <span class=\"token string\">''</span><span class=\"token punctuation\">,</span>\n    name<span class=\"token punctuation\">:</span> <span class=\"token string\">''</span><span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">}</span>\n\n  <span class=\"token function\">render</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token keyword\">const</span> <span class=\"token punctuation\">{</span> login<span class=\"token punctuation\">,</span> email<span class=\"token punctuation\">,</span> password<span class=\"token punctuation\">,</span> name <span class=\"token punctuation\">}</span> <span class=\"token operator\">=</span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span>state\n    <span class=\"token keyword\">return</span> <span class=\"token punctuation\">(</span>\n      <span class=\"token operator\">&lt;</span>div<span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span>h4 className<span class=\"token operator\">=</span><span class=\"token string\">\"mv3\"</span><span class=\"token operator\">></span><span class=\"token punctuation\">{</span>login <span class=\"token operator\">?</span> <span class=\"token string\">'Login'</span> <span class=\"token punctuation\">:</span> <span class=\"token string\">'Sign Up'</span><span class=\"token punctuation\">}</span><span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>h4<span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"flex flex-column\"</span><span class=\"token operator\">></span>\n          <span class=\"token punctuation\">{</span><span class=\"token operator\">!</span>login <span class=\"token operator\">&amp;&amp;</span> <span class=\"token punctuation\">(</span>\n            <span class=\"token operator\">&lt;</span>input\n              value<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>name<span class=\"token punctuation\">}</span>\n              onChange<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>e <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">setState</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span> name<span class=\"token punctuation\">:</span> e<span class=\"token punctuation\">.</span>target<span class=\"token punctuation\">.</span>value <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n              type<span class=\"token operator\">=</span><span class=\"token string\">\"text\"</span>\n              placeholder<span class=\"token operator\">=</span><span class=\"token string\">\"Your name\"</span>\n            <span class=\"token operator\">/</span><span class=\"token operator\">></span>\n          <span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n          <span class=\"token operator\">&lt;</span>input\n            value<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>email<span class=\"token punctuation\">}</span>\n            onChange<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>e <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">setState</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span> email<span class=\"token punctuation\">:</span> e<span class=\"token punctuation\">.</span>target<span class=\"token punctuation\">.</span>value <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n            type<span class=\"token operator\">=</span><span class=\"token string\">\"text\"</span>\n            placeholder<span class=\"token operator\">=</span><span class=\"token string\">\"Your email address\"</span>\n          <span class=\"token operator\">/</span><span class=\"token operator\">></span>\n          <span class=\"token operator\">&lt;</span>input\n            value<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>password<span class=\"token punctuation\">}</span>\n            onChange<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>e <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">setState</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span> password<span class=\"token punctuation\">:</span> e<span class=\"token punctuation\">.</span>target<span class=\"token punctuation\">.</span>value <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n            type<span class=\"token operator\">=</span><span class=\"token string\">\"password\"</span>\n            placeholder<span class=\"token operator\">=</span><span class=\"token string\">\"Choose a safe password\"</span>\n          <span class=\"token operator\">/</span><span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"flex mt3\"</span><span class=\"token operator\">></span>\n          <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"pointer mr2 button\"</span> onClick<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">_confirm</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span><span class=\"token operator\">></span>\n            <span class=\"token punctuation\">{</span>login <span class=\"token operator\">?</span> <span class=\"token string\">'login'</span> <span class=\"token punctuation\">:</span> <span class=\"token string\">'create account'</span><span class=\"token punctuation\">}</span>\n          <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n          <span class=\"token operator\">&lt;</span>div\n            className<span class=\"token operator\">=</span><span class=\"token string\">\"pointer button\"</span>\n            onClick<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">setState</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span> login<span class=\"token punctuation\">:</span> <span class=\"token operator\">!</span>login <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n          <span class=\"token operator\">></span>\n            <span class=\"token punctuation\">{</span>login\n              <span class=\"token operator\">?</span> <span class=\"token string\">'need to create an account?'</span>\n              <span class=\"token punctuation\">:</span> <span class=\"token string\">'already have an account?'</span><span class=\"token punctuation\">}</span>\n          <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n      <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n    <span class=\"token punctuation\">)</span>\n  <span class=\"token punctuation\">}</span>\n\n  _confirm <span class=\"token operator\">=</span> <span class=\"token keyword\">async</span> <span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token punctuation\">{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// ... you'll implement this 🔜</span>\n  <span class=\"token punctuation\">}</span>\n\n  _saveUserData <span class=\"token operator\">=</span> token <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token punctuation\">{</span>\n    localStorage<span class=\"token punctuation\">.</span><span class=\"token function\">setItem</span><span class=\"token punctuation\">(</span>AUTH_TOKEN<span class=\"token punctuation\">,</span> token<span class=\"token punctuation\">)</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n\n<span class=\"token keyword\">export</span> <span class=\"token keyword\">default</span> Login\n</code></pre>\n      </div>\n</Instruction>\n<p>Let’s quickly understand the structure of this new component, which can have two major states:</p>\n<ul>\n<li>One state is <strong>for users that already have an account</strong> and only need to login. In this state, the component will only render two <code>input</code> fields for the user to provide their <code>email</code> and <code>password</code>. Notice that <code>state.login</code> will be <code>true</code> in this case.</li>\n<li>The second state is for <strong>users that haven’t created an account yet</strong>, and thus still need to sign up. Here, you also render a third <code>input</code> field where users can provide their <code>name</code>. In this case, <code>state.login</code> will be <code>false</code>.</li>\n</ul>\n<p>The method <code>_confirm</code> will be used to implement the mutations that we need to send for the login functionality.</p>\n<p>Next you also need to provide the <code>constants.js</code> file that we use to define the key for the credentials that we’re storing in the browser’s <code>localStorage</code>.</p>\n<blockquote>\n<p><strong>Warning</strong>: Storing JWTs in <code>localStorage</code> is not a safe approach to implement authentication on the frontend. Because this tutorial is focused on GraphQL, we want to keep things simple and therefore are using it here. You can read more about this topic <a href=\"https://www.rdegges.com/2018/please-stop-using-local-storage/\">here</a>.</p>\n</blockquote>\n<Instruction>\n<p>In <code>src</code>, create a new file called <code>constants.js</code> and add the following definition:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/constants.js\"  nocopy=\"false\"><code><span class=\"token keyword\">export</span> <span class=\"token keyword\">const</span> AUTH_TOKEN <span class=\"token operator\">=</span> <span class=\"token string\">'auth-token'</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>With that component in place, you can go and add a new route to your <code>react-router-dom</code> setup.</p>\n<Instruction>\n<p>Open <code>App.js</code> and update <code>render</code> to include the new route:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/App.js\"  nocopy=\"false\"><code><span class=\"token function\">render</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">return</span> <span class=\"token punctuation\">(</span>\n    <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"center w85\"</span><span class=\"token operator\">></span>\n      <span class=\"token operator\">&lt;</span>Header <span class=\"token operator\">/</span><span class=\"token operator\">></span>\n      <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"ph3 pv1 background-gray\"</span><span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span>Switch<span class=\"token operator\">></span>\n          <span class=\"token operator\">&lt;</span>Route exact path<span class=\"token operator\">=</span><span class=\"token string\">\"/\"</span> component<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>LinkList<span class=\"token punctuation\">}</span> <span class=\"token operator\">/</span><span class=\"token operator\">></span>\n          <span class=\"token operator\">&lt;</span>Route exact path<span class=\"token operator\">=</span><span class=\"token string\">\"/create\"</span> component<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>CreateLink<span class=\"token punctuation\">}</span> <span class=\"token operator\">/</span><span class=\"token operator\">></span>\n<span class=\"gatsby-highlight-code-line\">          <span class=\"token operator\">&lt;</span>Route exact path<span class=\"token operator\">=</span><span class=\"token string\">\"/login\"</span> component<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>Login<span class=\"token punctuation\">}</span> <span class=\"token operator\">/</span><span class=\"token operator\">></span>\n</span>        <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>Switch<span class=\"token operator\">></span>\n      <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n    <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n  <span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Also import the <code>Login</code> component on top of the same file:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/App.js\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> Login <span class=\"token keyword\">from</span> <span class=\"token string\">'./Login'</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Finally, go ahead and add a <code>Link</code> to the <code>Header</code> that allows the users to navigate to the <code>Login</code> page.</p>\n<Instruction>\n<p>Open <code>Header.js</code> and update <code>render</code> to look as follows:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/Header.js\"  nocopy=\"false\"><code><span class=\"token function\">render</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">const</span> authToken <span class=\"token operator\">=</span> localStorage<span class=\"token punctuation\">.</span><span class=\"token function\">getItem</span><span class=\"token punctuation\">(</span>AUTH_TOKEN<span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">return</span> <span class=\"token punctuation\">(</span>\n    <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"flex pa1 justify-between nowrap orange\"</span><span class=\"token operator\">></span>\n      <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"flex flex-fixed black\"</span><span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"fw7 mr1\"</span><span class=\"token operator\">></span>Hacker News<span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n        <span class=\"token operator\">&lt;</span>Link to<span class=\"token operator\">=</span><span class=\"token string\">\"/\"</span> className<span class=\"token operator\">=</span><span class=\"token string\">\"ml1 no-underline black\"</span><span class=\"token operator\">></span>\n          <span class=\"token keyword\">new</span>\n        <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>Link<span class=\"token operator\">></span>\n        <span class=\"token punctuation\">{</span>authToken <span class=\"token operator\">&amp;&amp;</span> <span class=\"token punctuation\">(</span>\n          <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"flex\"</span><span class=\"token operator\">></span>\n            <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"ml1\"</span><span class=\"token operator\">></span><span class=\"token operator\">|</span><span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n            <span class=\"token operator\">&lt;</span>Link to<span class=\"token operator\">=</span><span class=\"token string\">\"/create\"</span> className<span class=\"token operator\">=</span><span class=\"token string\">\"ml1 no-underline black\"</span><span class=\"token operator\">></span>\n              submit\n            <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>Link<span class=\"token operator\">></span>\n          <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n        <span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n      <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n      <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"flex flex-fixed\"</span><span class=\"token operator\">></span>\n        <span class=\"token punctuation\">{</span>authToken <span class=\"token operator\">?</span> <span class=\"token punctuation\">(</span>\n          <span class=\"token operator\">&lt;</span>div\n            className<span class=\"token operator\">=</span><span class=\"token string\">\"ml1 pointer black\"</span>\n            onClick<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token punctuation\">{</span>\n              localStorage<span class=\"token punctuation\">.</span><span class=\"token function\">removeItem</span><span class=\"token punctuation\">(</span>AUTH_TOKEN<span class=\"token punctuation\">)</span>\n              <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span>props<span class=\"token punctuation\">.</span>history<span class=\"token punctuation\">.</span><span class=\"token function\">push</span><span class=\"token punctuation\">(</span><span class=\"token template-string\"><span class=\"token string\">`/`</span></span><span class=\"token punctuation\">)</span>\n            <span class=\"token punctuation\">}</span><span class=\"token punctuation\">}</span>\n          <span class=\"token operator\">></span>\n            logout\n          <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n        <span class=\"token punctuation\">)</span> <span class=\"token punctuation\">:</span> <span class=\"token punctuation\">(</span>\n          <span class=\"token operator\">&lt;</span>Link to<span class=\"token operator\">=</span><span class=\"token string\">\"/login\"</span> className<span class=\"token operator\">=</span><span class=\"token string\">\"ml1 no-underline black\"</span><span class=\"token operator\">></span>\n            login\n          <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>Link<span class=\"token operator\">></span>\n        <span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n      <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n    <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n  <span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>You first retrieve the <code>authToken</code> from local storage. If the <code>authToken</code> is not available, the <strong>submit</strong>-button won’t be rendered any more. That way you make sure only authenticated users can create new links.</p>\n<p>You’re also adding a second button to the right of the <code>Header</code> that users can use to login and logout.</p>\n<Instruction>\n<p>Lastly, you need to import the key definition from <code>constants.js</code> in <code>Header.js</code>. Add the following statement to the top of file:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/Header.js\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span> AUTH_TOKEN <span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'../constants'</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Here is what the ready component looks like:</p>\n<p><img src=\"http://imgur.com/tBxMVtb.png\"></p>\n<p>Perfect, you’re all set now to implement the authentication functionality.</p>\n<h3>Using the authentication mutations</h3>\n<p><code>signup</code> and <code>login</code> are two regular GraphQL mutations you can use in the same way as you did with the <code>createLink</code> mutation from before.</p>\n<Instruction>\n<p>Open <code>Login.js</code> and add the following two definitions to the top of the file:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/Login.js\"  nocopy=\"false\"><code><span class=\"token keyword\">const</span> SIGNUP_MUTATION <span class=\"token operator\">=</span> gql<span class=\"token template-string\"><span class=\"token string\">`\n  mutation SignupMutation($email: String!, $password: String!, $name: String!) {\n    signup(email: $email, password: $password, name: $name) {\n      token\n    }\n  }\n`</span></span>\n\n<span class=\"token keyword\">const</span> LOGIN_MUTATION <span class=\"token operator\">=</span> gql<span class=\"token template-string\"><span class=\"token string\">`\n  mutation LoginMutation($email: String!, $password: String!) {\n    login(email: $email, password: $password) {\n      token\n    }\n  }\n`</span></span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Both mutations look very similar to the mutations you already saw before. They take a number of arguments and return the <code>token</code> that you can attach to subsequent requests to authenticate the user (i.e. indicate that a request is made <em>on behalf</em> of that user). You’ll learn 🔜 how to do so.</p>\n<Instruction>\n<p>Next, find the <code>div</code> element that has the class names <code>flex mt3</code> and replace it with the following:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/Login.js\"  nocopy=\"false\"><code><span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"flex mt3\"</span><span class=\"token operator\">></span>\n<span class=\"gatsby-highlight-code-line\">  <span class=\"token operator\">&lt;</span>Mutation\n</span><span class=\"gatsby-highlight-code-line\">    mutation<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>login <span class=\"token operator\">?</span> LOGIN_MUTATION <span class=\"token punctuation\">:</span> SIGNUP_MUTATION<span class=\"token punctuation\">}</span>\n</span><span class=\"gatsby-highlight-code-line\">    variables<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">{</span> email<span class=\"token punctuation\">,</span> password<span class=\"token punctuation\">,</span> name <span class=\"token punctuation\">}</span><span class=\"token punctuation\">}</span>\n</span><span class=\"gatsby-highlight-code-line\">    onCompleted<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>data <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">_confirm</span><span class=\"token punctuation\">(</span>data<span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n</span><span class=\"gatsby-highlight-code-line\">  <span class=\"token operator\">></span>\n</span><span class=\"gatsby-highlight-code-line\">    <span class=\"token punctuation\">{</span>mutation <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token punctuation\">(</span>\n</span><span class=\"gatsby-highlight-code-line\">      <span class=\"token operator\">&lt;</span>div className<span class=\"token operator\">=</span><span class=\"token string\">\"pointer mr2 button\"</span> onClick<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span>mutation<span class=\"token punctuation\">}</span><span class=\"token operator\">></span>\n</span><span class=\"gatsby-highlight-code-line\">        <span class=\"token punctuation\">{</span>login <span class=\"token operator\">?</span> <span class=\"token string\">'login'</span> <span class=\"token punctuation\">:</span> <span class=\"token string\">'create account'</span><span class=\"token punctuation\">}</span>\n</span><span class=\"gatsby-highlight-code-line\">      <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n</span><span class=\"gatsby-highlight-code-line\">    <span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n</span><span class=\"gatsby-highlight-code-line\">  <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>Mutation<span class=\"token operator\">></span>\n</span>  <span class=\"token operator\">&lt;</span>div\n    className<span class=\"token operator\">=</span><span class=\"token string\">\"pointer button\"</span>\n    onClick<span class=\"token operator\">=</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">setState</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span> login<span class=\"token punctuation\">:</span> <span class=\"token operator\">!</span>login <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">}</span>\n  <span class=\"token operator\">></span>\n    <span class=\"token punctuation\">{</span>login <span class=\"token operator\">?</span> <span class=\"token string\">'need to create an account?'</span> <span class=\"token punctuation\">:</span> <span class=\"token string\">'already have an account?'</span><span class=\"token punctuation\">}</span>\n  <span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n<span class=\"token operator\">&lt;</span><span class=\"token operator\">/</span>div<span class=\"token operator\">></span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Before we take a closer look at the <code>&#x3C;Mutation /></code> component implementation, go ahead and add the required imports.</p>\n<Instruction>\n<p>Still in <code>Login.js</code>, add the following statement to the top of the file:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/Login.js\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span> Mutation <span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'react-apollo'</span>\n<span class=\"token keyword\">import</span> gql <span class=\"token keyword\">from</span> <span class=\"token string\">'graphql-tag'</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Now, let’s understand what’s going with the <code>&#x3C;Mutation /></code> component you just added.</p>\n<p>The code is pretty straightforward. If the user wants to just login, you’re calling the <code>loginMutation</code>, otherwise you’re using the <code>signupMutation</code>, and the mutation will be triggered on the div’s <code>onClick</code> event. GraphQL mutations receive the <code>email</code>, <code>password</code> and <code>name</code> state values as params passed on the <code>variables</code> prop. Lastly, after the mutation has finished, we call the <code>_confirm</code> function, passing the <code>data</code> returned by the mutation as an argument.</p>\n<p>All right, all that’s left to do is implement the <code>_confirm</code> function!</p>\n<Instruction>\n<p>Open <code>Login.js</code> and update <code>_confirm</code> as follows:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/components/Login.js\"  nocopy=\"false\"><code>_confirm <span class=\"token operator\">=</span> <span class=\"token keyword\">async</span> data <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">const</span> <span class=\"token punctuation\">{</span> token <span class=\"token punctuation\">}</span> <span class=\"token operator\">=</span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span>state<span class=\"token punctuation\">.</span>login <span class=\"token operator\">?</span> data<span class=\"token punctuation\">.</span>login <span class=\"token punctuation\">:</span> data<span class=\"token punctuation\">.</span>signup\n  <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">_saveUserData</span><span class=\"token punctuation\">(</span>token<span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span>props<span class=\"token punctuation\">.</span>history<span class=\"token punctuation\">.</span><span class=\"token function\">push</span><span class=\"token punctuation\">(</span><span class=\"token template-string\"><span class=\"token string\">`/`</span></span><span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>After the mutation was performed, you’re storing the returned <code>token</code> in <code>localStorage</code> and navigating back to the root route.</p>\n<blockquote>\n<p><strong>Note</strong>: Mutation returned <code>data</code> relies on GraphQL mutation definition, that’s why we need to get the <code>token</code> depending on which mutation is triggered.</p>\n</blockquote>\n<p>You can now create an account by providing a <code>name</code>, <code>email</code> and <code>password</code>. Once you did that, the <strong>submit</strong>-button will be rendered again:</p>\n<p><img src=\"https://imgur.com/z4KILTw.png\"></p>\n<p>If you haven’t done so before, go ahead and test the login functionality. Run <code>yarn start</code> and open <code>http://localhost:3000/login</code>. Then click the <strong>need to create an account?</strong>-button and provide some user data for the user you’re creating. Finally, click the <strong>create account</strong>-button. If all went well, the app navigates back to the root route and your user was created. You can verify that the new user is there by sending the <code>users</code> query in the <strong>dev</strong> Playground in the <strong>database</strong> project.</p>\n<h3>Configuring Apollo with the authentication token</h3>\n<p>Now that users are able to login and obtain a token that authenticates them against the GraphQL server, you actually need to make sure that the token gets attached to all requests that are sent to the API.</p>\n<p>Since all the API requests are actually created and sent by the <code>ApolloClient</code> instance in your app, you need to make sure it knows about the user’s token! Luckily, Apollo provides a nice way for authenticating all requests by using the concept of <a href=\"http://dev.apollodata.com/react/auth.html#Header\">middleware</a>, implemented as an <a href=\"https://github.com/apollographql/apollo-link\">Apollo Link</a>.</p>\n<p>First, you need to add the required dependencies to the app. Open a terminal, navigate to your project directory and type:</p>\n<Instruction>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"  path=\".../hackernews-react-apollo\"  nocopy=\"false\"><code>yarn add apollo-link-context\n</code></pre>\n      </div>\n</Instruction>\n<p>Let’s see the authentication link in action!</p>\n<Instruction>\n<p>Open <code>index.js</code> and put the following code <em>between</em> the creation of the <code>httpLink</code> and the instantiation of <code>ApolloClient</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/index.js\"  nocopy=\"false\"><code><span class=\"token keyword\">const</span> authLink <span class=\"token operator\">=</span> <span class=\"token function\">setContext</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">(</span>_<span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span> headers <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">const</span> token <span class=\"token operator\">=</span> localStorage<span class=\"token punctuation\">.</span><span class=\"token function\">getItem</span><span class=\"token punctuation\">(</span>AUTH_TOKEN<span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">return</span> <span class=\"token punctuation\">{</span>\n    headers<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token operator\">...</span>headers<span class=\"token punctuation\">,</span>\n      authorization<span class=\"token punctuation\">:</span> token <span class=\"token operator\">?</span> <span class=\"token template-string\"><span class=\"token string\">`Bearer </span><span class=\"token interpolation\"><span class=\"token interpolation-punctuation punctuation\">${</span>token<span class=\"token interpolation-punctuation punctuation\">}</span></span><span class=\"token string\">`</span></span> <span class=\"token punctuation\">:</span> <span class=\"token string\">''</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Before moving on, you need to import the Apollo dependencies. Add the following to the top of <code>index.js</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/index.js\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span> setContext <span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'apollo-link-context'</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>This middleware will be invoked every time <code>ApolloClient</code> sends a request to the server. Apollo Links allow you to create <code>middlewares</code> that let you modify requests before they are sent to the server.</p>\n<p>Let’s see how it works in our code: first, we get the authentication <code>token</code> from <code>localStorage</code> if it exists; after that, we return the <code>headers</code> to the <code>context</code> so <code>httpLink</code> can read them.</p>\n<blockquote>\n<p><strong>Note</strong>: You can read more about Apollo’s authentication <a href=\"https://www.apollographql.com/docs/react/recipes/authentication.html\">here</a>.</p>\n</blockquote>\n<Instruction>\n<p>Now you also need to make sure <code>ApolloClient</code> gets instantiated with the correct link - update the constructor call as follows:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/index.js\"  nocopy=\"false\"><code><span class=\"token keyword\">const</span> client <span class=\"token operator\">=</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">ApolloClient</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n<span class=\"gatsby-highlight-code-line\">  link<span class=\"token punctuation\">:</span> authLink<span class=\"token punctuation\">.</span><span class=\"token function\">concat</span><span class=\"token punctuation\">(</span>httpLink<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n</span>  cache<span class=\"token punctuation\">:</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">InMemoryCache</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Then directly import the key you need to retrieve the token from <code>localStorage</code> on top of the same file:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/src/index.js\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span> AUTH_TOKEN <span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'./constants'</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>That’s it - now all your API requests will be authenticated if a <code>token</code> is available.</p>\n<h3>Requiring authentication on the server-side</h3>\n<p>The last thing you might do in this chapter is check how to ensure only authenticated users are able to <code>post</code> new links. Plus, every <code>Link</code> that’s created by a <code>post</code> mutation should automatically set the <code>User</code> who sent the request for its <code>postedBy</code> field.</p>\n<Instruction>\n<p>Open <code>/server/src/resolvers/Mutation.js</code> and give a look how it was implemented:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-js\"  path=\".../hackernews-react-apollo/server/src/resolvers/Mutation.js\"  nocopy=\"false\"><code><span class=\"token keyword\">function</span> <span class=\"token function\">post</span><span class=\"token punctuation\">(</span>parent<span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span> url<span class=\"token punctuation\">,</span> description <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> ctx<span class=\"token punctuation\">,</span> info<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">const</span> userId <span class=\"token operator\">=</span> <span class=\"token function\">getUserId</span><span class=\"token punctuation\">(</span>ctx<span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">return</span> ctx<span class=\"token punctuation\">.</span>db<span class=\"token punctuation\">.</span>mutation<span class=\"token punctuation\">.</span><span class=\"token function\">createLink</span><span class=\"token punctuation\">(</span>\n    <span class=\"token punctuation\">{</span> data<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span> url<span class=\"token punctuation\">,</span> description<span class=\"token punctuation\">,</span> postedBy<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span> connect<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span> id<span class=\"token punctuation\">:</span> userId <span class=\"token punctuation\">}</span> <span class=\"token punctuation\">}</span> <span class=\"token punctuation\">}</span> <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n    info<span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>With this, you’re extracting the <code>userId</code> from the <code>Authorization</code> header of the request and use it to directly <a href=\"https://www.prismagraphql.com/docs/reference/prisma-api/mutations-ol0yuoz6go#nested-mutations\"><code>connect</code></a> it with the <code>Link</code> that’s created. Note that <code>getUserId</code> will <a href=\"https://github.com/howtographql/react-apollo/blob/master/server/src/utils.js#L12\">throw an error</a> if the field is not provided or not valid token could be extracted.</p>",
				"fields": {
					"slug": "/react-apollo/5-authentication/"
				},
				"excerpt": "In this section, you’ll learn how you can implement authentication functionality with Apollo to provide signup and login features to your...",
				"frontmatter": {
					"title": "Authentication",
					"videoId": "",
					"videoAuthor": "",
					"parent": "/opt/build/repo/content/frontend/react-apollo/5-authentication.md absPath of file",
					"question": "How are HTTP requests sent by ApolloClient authenticated?",
					"answers": [
						"The ApolloClient needs to be instantiated with an authentication token",
						"ApolloClient exposes an extra method called 'authenticate' where you can pass an authentication token",
						"By attaching an authentication token to the request with dedicated ApolloLink middleware",
						"ApolloClient has nothing to do with authentication"
					],
					"correctAnswer": 2,
					"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a React app with Prisma.",
					"pageTitle": "Authentication with GraphQL, React & Apollo Tutorial"
				}
			},
			"mds": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"title": "Get started with your favorite technology",
								"description": null
							},
							"fields": {
								"slug": "/choose/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "It was great having you!",
								"description": null
							},
							"fields": {
								"slug": "/success/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-elixir/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Elixir & Absinthe as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-elixir/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Absinthe & Elixir. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-elixir/4-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with Absinthe, implement query resolvers in Elixir and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-yoga, Node.js & Prisma and best practices for authentication, filtering, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Node.js & Express as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-js/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Query",
								"description": "Learn how to define a GraphQL schema, implement query resolvers with Node.js and test your queries in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/2-a-simple-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Adding a Database",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/4-adding-a-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Mutation",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-js, Node.js & Prisma. Test your implementation in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/3-a-simple-mutation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Server and Database with the Prisma Client",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/5-connecting-server-and-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime GraphQL Subscriptions",
								"description": "Learn how to implement GraphQL subscriptions with Node.js, Express & Prisma to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-js/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing authentication and authorization with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/6-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering, Pagination & Sorting",
								"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/8-filtering-pagination-and-sorting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Node.js and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Building a Server with GraphQL and Graphene"
							},
							"fields": {
								"slug": "/graphql-python/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Setting up a Django Graphene Project"
							},
							"fields": {
								"slug": "/graphql-python/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Tutorial Summary"
							},
							"fields": {
								"slug": "/graphql-python/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Creating Data With Mutations"
							},
							"fields": {
								"slug": "/graphql-python/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Creating Your First Queries"
							},
							"fields": {
								"slug": "/graphql-python/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Authenticating on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Links and Voting",
								"description": "Enable Users to create Links and to Vote on them"
							},
							"fields": {
								"slug": "/graphql-python/5-links-and-voting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Handling Errors on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Filtering GraphQL Queries"
							},
							"fields": {
								"slug": "/graphql-python/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Simple Pagination with Graphene"
							},
							"fields": {
								"slug": "/graphql-python/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relay",
								"description": "Using Relay on Graphene"
							},
							"fields": {
								"slug": "/graphql-python/9-relay/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-java/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-java and best practices for defining the GraphQL schema in this tutorial."
							},
							"fields": {
								"slug": "/graphql-java/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with a Node.js & Express GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/10-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Alternative approaches to schema development",
								"description": "Learn about an alternative approach to developing schemas with graphl-java with graphql-spqr"
							},
							"fields": {
								"slug": "/graphql-java/11-alternative-approaches/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-java/12-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-java, implement query resolvers in Java and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-java & Java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connectors",
								"description": "Learn how to write connectors in Java to load data from MongoDB with graphql-java and a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/4-connectors/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Java."
							},
							"fields": {
								"slug": "/graphql-java/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Java and graphql-java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/6-more-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Subscriptions",
								"description": "Learn how to implement server-side GraphQL subscriptions with Java to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-java/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Java, Node.js & Express."
							},
							"fields": {
								"slug": "/graphql-java/7-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/9-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-ruby and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-ruby/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-ruby and best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-ruby/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-ruby, implement query resolvers in Ruby and use a GraphiQL Playground to test your queries."
							},
							"fields": {
								"slug": "/graphql-ruby/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Nodes",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/5-connecting-nodes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/graphql-scala/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "In this chapter will be described how to setup the HTTP server, install all dependencies and setup the database."
							},
							"fields": {
								"slug": "/graphql-scala/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-ruby & Ruby and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-ruby/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "The first query",
								"description": "In this chapter you will learn last steps of preparation, add graphiql console for easy debugging and at the end, run your first query."
							},
							"fields": {
								"slug": "/graphql-scala/2-preparing-first-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Handling Arguments",
								"description": "In this chapter you will learn how to use arguments and how to handle them and pass to the business logic."
							},
							"fields": {
								"slug": "/graphql-scala/3-handling_arguments/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Custom Scalars",
								"description": "In this chapter Link model will get an additional field to store date and time. You will learn how to handle such custom types and use scalars."
							},
							"fields": {
								"slug": "/graphql-scala/5-custom_scalars/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deferred Resolvers",
								"description": "In this chapter you will learn how to improve performance with deferred resolvers."
							},
							"fields": {
								"slug": "/graphql-scala/4-deferred_resolvers/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Interfaces",
								"description": "In this chapter we will introduce two additional models. We show the most common parts and extract those as an interface. This time you will work alone."
							},
							"fields": {
								"slug": "/graphql-scala/6-interfaces/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relations",
								"description": "In this chapter you will learn how to connect models with relations. You will also learn how to prepare fetchers to use either relations or ids to get entities."
							},
							"fields": {
								"slug": "/graphql-scala/7-relations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "In this chapter you will learn how to add data to the database."
							},
							"fields": {
								"slug": "/graphql-scala/8-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Sangria's Middleware allows pre-processing queries. Gather all useful data in the following subqueries."
							},
							"fields": {
								"slug": "/graphql-scala/9-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Angular & Apollo Client. You'll use angular-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/angular-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with angular-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with Angular and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/angular-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading link-items",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Angular & Apollo Client you learned how to build a production-ready Hackernews clone using angular-cli & Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's service injected in the component to define and send mutations."
							},
							"fields": {
								"slug": "/angular-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use Angular Router  together with GraphQL and Apollo Client to implement navigation in an Angular app."
							},
							"fields": {
								"slug": "/angular-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Angular app with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/angular-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & Angular. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/angular-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, React & Apollo Client. Use create-react-app for the frontend and graphql-yoga & Prisma for the backend."
							},
							"fields": {
								"slug": "/react-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a Angular app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/angular-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Apollo Client you learned how to build a production-ready Hackernews clone using create-react-app & Prisma."
							},
							"fields": {
								"slug": "/react-apollo/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `<Mutation />` component to define and send mutations."
							},
							"fields": {
								"slug": "/react-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use react-router 4 together with GraphQL and Apollo Client to implement navigation in a React app. Each route will be represented as a `Link`."
							},
							"fields": {
								"slug": "/react-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a React app with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Prisma provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/react-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a React app. The Prisma API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/react-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a production-ready Hackernews clone with GraphQL, React & Relay. You'll use create-react-app for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/react-relay/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL Fragments and Relay's QueryRenderer to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-relay/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how to use Relay Modern's new Mutation API to send mutations to a GraphQL server. With Relay Modern you can also update the cache directly after the mutation."
							},
							"fields": {
								"slug": "/react-relay/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": null
							},
							"fields": {
								"slug": "/react-relay/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Relay to provide an email-and-password-based login in a React app with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Relay Modern & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-relay/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Relay Modern's imperative API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-relay/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement cursor-based pagination with GraphQL and Relay Modern using `PaginationContainer`. Relay uses the concept of connections to represent lists."
							},
							"fields": {
								"slug": "/react-relay/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Relay Modern you learned how to build a production-ready Hackernews clone using create-react-app & Graphcool."
							},
							"fields": {
								"slug": "/react-relay/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Clients",
								"description": "Learn about GraphQL clients, like Relay and Apollo Client, and the features they provide, such as caching, schema validation and query/view colocation."
							},
							"fields": {
								"slug": "/advanced/0-clients/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More GraphQL Concepts",
								"description": "Learn about advanced concepts of the GraphQL language like fragments, query arguments, aliases, interfaces and more SDL features"
							},
							"fields": {
								"slug": "/advanced/2-more-graphql-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Server",
								"description": "Learn about the major concepts of GraphQL servers, how it executes GraphQL queries with resolver functions and batches multiple requests."
							},
							"fields": {
								"slug": "/advanced/1-server/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Tooling and Ecosystem",
								"description": "Learn about the GraphQL ecosystem and its awesome tooling like the GraphiQL playgrounds or self-generating docs through introspection."
							},
							"fields": {
								"slug": "/advanced/3-tooling-and-ecosystem/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Security",
								"description": "Learn about different security aspects and strategies for GraphQL, such as timeouts, maximum query depth, query complexity and throttling."
							},
							"fields": {
								"slug": "/advanced/4-security/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Common Questions",
								"description": "Answer common GraphQL questions about server-side caching, authentication, authorization, error handling, offline usage and more."
							},
							"fields": {
								"slug": "/advanced/5-common-questions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, VueJS & Apollo Client. You'll use vue-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/vue-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with VueJS & Apollo Client you learned how to build a production-ready Hackernews clone using vue-cli & Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `mutate` method to define and send mutations."
							},
							"fields": {
								"slug": "/vue-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use vue-router together with GraphQL and Apollo Client to implement navigation in a VueJS app."
							},
							"fields": {
								"slug": "/vue-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with vue-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with VueJS and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/vue-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a VueJS app with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/vue-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & VueJS. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/vue-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn all about GraphQL and why it is an API technology that's superior to REST. It is not only for React & Javascript developers but can be used for any API."
							},
							"fields": {
								"slug": "/basics/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "GraphQL is the better REST",
								"description": "Learn why GraphQL is a more efficient and flexible alternative to REST APIs. It has a strong type system and avoids frontend issues like over- and underfetching."
							},
							"fields": {
								"slug": "/basics/1-graphql-is-the-better-rest/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Core Concepts",
								"description": "Learn about the basic GraphQL language concepts, such as Queries, Mutations, Subscriptions and the GraphQL Schema & SDL. Try them out in your own sandbox."
							},
							"fields": {
								"slug": "/basics/2-core-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Ember, and Apollo Client. You'll use Ember and ember-apollo-client for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/ember-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Big Picture (Architecture)",
								"description": "Learn about different architectural use cases of GraphQL and the major components on the backend and the frontend, like resolver functions and client libraries."
							},
							"fields": {
								"slug": "/basics/3-big-picture/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with ember-cli, ember-apollo-client, and the backend with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/ember-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Navigation",
								"description": "Learn how to use Ember components together with GraphQL and Apollo Client to implement navigation in an Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/4-navigation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use `ember-apollo-client` to send mutations."
							},
							"fields": {
								"slug": "/ember-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/ember-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Ember & Apollo Client you learned how to build a production-ready Hackernews clone using ember-apollo-client & Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/8-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a VueJS app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/vue-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Ember app with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/5-authentication/"
							}
						}
					}
				]
			}
		},
		"pathContext": {
			"slug": "/react-apollo/5-authentication/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---react-apollo-5-authentication-369e5d4aa3322070a439.js